import { Document as DocumentIcon, CheckCircle as CheckCircleIcon } from '@hourly-hds/icons/glyph';
import type { ReactNode } from 'react';
import styles from './Document.module.css';

interface DocumentProps {
  isCompleted: boolean;
  children: ReactNode;
}

const Document = ({ isCompleted, children }: DocumentProps) => {
  return (
    <div className={styles.document}>
      {isCompleted ? <CheckCircleIcon className={styles.success} /> : <DocumentIcon />}
      <span className={styles.documentLabel}>{children}</span>
    </div>
  );
};

export default Document;
